import React from 'react'
import {request} from '../../helpers/request.js';
import {t} from '../../helpers/translate.js';
import ModalComponent from './ModalComponent';
import ConfirmationScreenComponent from './ConfirmationScreenComponent';
import { Link } from 'react-router';
import {checkOrg, isSchoolAdmin} from '../../helpers/access'
let config = require('config');

class RenewalEmailComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      to: [],
      cc: this.props.ccEmail ? this.getDefaultCC(this.props.ccEmail) : '',
      agentCc: this.props.agentEmail ? this.getDefaultCC(this.props.agentEmail) : '',
      showModal: false,
      modalTitle: null,
      modalBody: null,
      modalSize: null,
      defaultCC: this.props.defaultCC ? this.getDefaultCC(this.props.defaultCC) : config.default.email.policyConfirmation.cc
    }
  }

  componentWillMount() {
    this.getDefaultEmail();
  }

  handleModalClose() {
    this.setState({
      showModal: false
    });
  }

  showModal(title, body, size = null) {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title,
      modalSize: size
    });
  }

  getDefaultCC(defaultCC){
    if( typeof defaultCC === 'string' ) {
        return [defaultCC];
    }
    return defaultCC;
  }

  getDefaultEmail(){
    const to = [this.props.defaultEmail(this.props.context)];
    this.setState({
      to: to
    });
    return to;
  }

  handleViewKeyPressed() {
    this.props.showLoading('Loading Preview');
    request(`${config.default.api}/${'renewalnotice'}/${this.props.source}/${this.props.applicationId}`, 'GET', null, (data, statusCode) => {
      if (statusCode == 200) {
        this.showModal(t('View Renewal Notice'), <ConfirmationScreenComponent data={data} />, 'lg');
      } else {
        this.showModal('Error', `Unable to generate renewal screen (code ${statusCode}).`);
      }
      this.props.hideLoading();
    });
  }

  getLink() {
    const state = {
      source: this.props.source,
      applicationId: this.props.applicationId,
      paymentProvider: this.props.paymentProvider,
      trackingCode: this.props.trackingCode,
    }

    return {
      state: state,
      pathname: `/application_form`
    }
  }

  getAllCcEmails(){
    return [
      ...this.state.cc,
      ...this.state.agentCc,
      ...this.state.defaultCC,
    ];
  }

  handleSendKeyPressed(event) {
    this.props.showLoading('Sending Renewal Notice');
    let hidePremiumConfig = config.default.clients[this.props.source].hidePremium;
    if (hidePremiumConfig === undefined) {
      hidePremiumConfig = false;
    }

    request(`${config.default.api}/renewalnotification/${this.props.source}/email/${this.props.applicationId}`, 'POST', {
      to: this.getDefaultEmail().filter(x => x.trim()),
      cc: this.getAllCcEmails().filter(x => x.trim()),
      hidePremium: hidePremiumConfig
    }, (data, status) => {
      if (status == 200) {
        this.showModal(t('Success'), `${t('A renewal notification has been sent to')} ${this.state.to.join(', ')}.`);
      } else if (status == 500) {
        this.showModal(t('Error'), t('Unable to send Renewal Notification'));
      } else {
        this.showModal(t('Error'), <div>{data.messages.map((message) =>
          <p>{t(message)}</p>)}</div>);
        event.preventDefault();
      }
      this.props.hideLoading();
    }, {'Accept-Language': this.props.locale});
  }

  render() {
    return (
      <div>
        {!isSchoolAdmin() && <div className="row">
          <div className="col-md-12">
            <div className="btn-group pull-left">
              <button className="btn button-primary" onClick={this.handleViewKeyPressed.bind(this)}>
                {t('View Renewal Notice')}
              </button>
              <button className="btn button-secondary" onClick={this.handleSendKeyPressed.bind(this)}>
                {t('Send Renewal Notice')}
              </button>
            </div>
          </div>
        </div>
        }
        <br />
        <div className="row">
          <div className="col-md-12">
            <div className="btn-group pull-left">
              <Link
                className='btn button-secondary pull-right listing-header-link'
                to={this.getLink()}
              >{t('Issue Related Policy')}</Link>
            </div>
          </div>
        </div>
        <ModalComponent
          title={t(this.state.modalTitle)}
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showModal}
          size={this.state.modalSize}
        />
      </div>
    );
  }
}

RenewalEmailComponent.displayName = 'RenewalEmailComponent';
export default RenewalEmailComponent;



// WEBPACK FOOTER //
// ./src/components/common/RenewalEmailComponent.js